import "./css/Modal.css";

import { Box } from "@mui/material";
import type { ComponentChildren } from "preact";

import { BaseModal } from "./BaseModal";
import { TextButton } from "./TextButton";

type SelectionOption = {
  text: string;
  onClicked: () => void;
};

type ModalProps = {
  shown: boolean;
  titleText?: string;
  descriptionText?: string | JSX.Element[];
  onYes?: SelectionOption;
  onBtns?: SelectionOption[];
  onNo?: SelectionOption;
  children?: ComponentChildren;
};

export const Modal = (props: ModalProps) => {
  return (
    <BaseModal aria-labelledby="modal-title" aria-describedby="modal-description" open={props.shown}>
      <Box className="modalBox supportsRtl">
        {props.titleText ? (
          <div id="modal-title" className="modalTitle">
            {props.titleText}
          </div>
        ) : null}
        {props.descriptionText ? (
          <div id="modal-description" className="modalDescription">
            {props.descriptionText}
          </div>
        ) : null}

        {props.children}

        <div className="modalButtonContainer">
          {props.onYes ? <ModalSelectionOption selectionOption={props.onYes} className="modalYesButton" /> : null}
          {props.onBtns?.map((btn, index) => (
            <div key={index}>
              <ModalSelectionOption selectionOption={btn} className="modalYesButton" />
            </div>
          ))}
          {props.onNo ? <ModalSelectionOption selectionOption={props.onNo} className="modalNoButton" /> : null}
        </div>
      </Box>
    </BaseModal>
  );
};

function ModalSelectionOption({
  selectionOption,
  className,
}: {
  selectionOption: SelectionOption;
  className?: string;
}) {
  return (
    <TextButton className={className} onClick={selectionOption.onClicked}>
      {selectionOption.text}
    </TextButton>
  );
}
